import { action } from 'satcheljs';

export default action('SELECT_PREVIOUS_NODE_INTERNAL', (actionSource: string) => {
    return { actionSource: actionSource };
});
